// extracted by mini-css-extract-plugin
export default {"red":"DeleteModal-module__red___xtExV","body":"DeleteModal-module__body___F7XJu"};